import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-quill-new/dist/quill.snow.css';
import './styles/blog.css';


// Layout & Guards
import Layout from './components/Layout';
import PrivateRoute from './components/PrivateRoute';

// Auth
import Login from './pages/Login';

// Dashboard
import Dashboard from './pages/Dashboard';

// Users
import Users from './pages/Users';
import UserSettings from './pages/UserSettings';

// Organization
import OrganizationSettings from './pages/OrganizationSettings';
import CreateOrganization from './pages/CreateOrganization';

// Bids
import Bids from './pages/Bids';
import BidForm from './pages/BidForm';

// Blogs
import Blogs from './pages/Blogs';
import BlogForm from './pages/BlogForm';

// Vacancies
import Vacancies from './pages/Vacancies';
import VacancyForm from './pages/VacancyForm';

//categories
import CategoryForm from './pages/CategoriesForm';
import Categories from './pages/Categories';

// Bursaries
import Bursaries from './pages/Bursaries';
import BursaryForm from './pages/BursaryForm';

// Gallery
import Gallery from './pages/Gallery';
import GalleryForm from './pages/GalleryForm';

// Projects
import Projects from './pages/Projects';
import ProjectForm from './pages/ProjectForm';

//events
import EventsPage               from './pages/EventsPage';
import EventFormPage            from './pages/EventFormPage';
import EventDetailPage          from './pages/EventDetailPage';
import EventRegistrationsPage   from './pages/EventRegistrationsPage';

import 'react-quill-new/dist/quill.snow.css';
import './styles/blog.css';

function App() {
  return (
    <Routes>
      {/* Public */}
      <Route path="/login" element={<Login />} />

      {/* Protected */}
      <Route element={<PrivateRoute />}>
        <Route element={<Layout />}>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<Dashboard />} />

          {/* Users */}
          <Route path="/users" element={<Users />} />
          <Route path="/users/settings" element={<UserSettings />} />

          {/* Organization */}
          <Route path="/organization/settings" element={<OrganizationSettings />} />
          <Route path="/organization/create" element={<CreateOrganization />} />

          {/* Bids */}
          <Route path="/bids" element={<Bids />} />
          <Route path="/bids/new" element={<BidForm />} />
          <Route path="/bids/edit/:id" element={<BidForm />} />

          {/* Blogs */}
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/blogs/new" element={<BlogForm />} />
          <Route path="/blogs/edit/:id" element={<BlogForm />} />

          {/* Vacancies */}
          <Route path="/vacancies" element={<Vacancies />} />
          <Route path="/vacancies/new" element={<VacancyForm />} />
          <Route path="/vacancies/edit/:id" element={<VacancyForm />} />

          {/* Categories */}
          <Route path="/categories" element={<Categories />} />
          <Route path="/categories/new" element={<CategoryForm />} />
          <Route path="/categories/edit/:id" element={<CategoryForm />} />          

          {/* Bursaries */}
          <Route path="/bursaries" element={<Bursaries />} />
          <Route path="/bursaries/new" element={<BursaryForm />} />
          <Route path="/bursaries/edit/:id" element={<BursaryForm />} />

          {/* Gallery */}
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/gallery/new" element={<GalleryForm />} />
          <Route path="/gallery/edit/:id" element={<GalleryForm />} />

          {/* Projects */}
          <Route path="/projects" element={<Projects />} />
          <Route path="/projects/new" element={<ProjectForm />} />
          <Route path="/projects/edit/:id" element={<ProjectForm />} />

          {/* events */}
          <Route path="/events"                              element={<EventsPage />} />
          <Route path="/events/new"                          element={<EventFormPage />} />
          <Route path="/events/:id"                          element={<EventDetailPage />} />
          <Route path="/events/:id/edit"                     element={<EventFormPage />} />
          <Route path="/events/:id/registrations"            element={<EventRegistrationsPage />} />
                    
        </Route>
      </Route>

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
